/** Student tutors detail tab. */
import * as React from 'react';
import { UserCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DetailsCard } from '@/components/common/DetailsCard';
import { DetailField } from '@/components/common/details/DetailField';

/** Paired tutor shown on the remote student tutors tab. */
interface AccompanyingTutor {
  binomeId: string;
  tutorUserId: string;
  name: string;
  program?: string | null;
  managedByName: string;
}

/** Props for {@link StudentTutorsTab}. */
interface StudentTutorsTabProps {
  accompanyingTutors: AccompanyingTutor[];
}

/** Student tutors detail tab. */
export const StudentTutorsTab: React.FC<StudentTutorsTabProps> = ({ accompanyingTutors }) => {
  const navigate = useNavigate();

  return (
    <div className="details-view-grid mt-6">
      {accompanyingTutors.length === 0 ? (
        <p className="text-sm text-muted-foreground">Aucun tuteur associé</p>
      ) : (
        accompanyingTutors.map((t) => (
          <button
            key={t.binomeId}
            type="button"
            className="section-card-compact appearance-none border-0 bg-transparent p-0 text-left cursor-pointer"
            onClick={() =>
              navigate(`/tutors?view=${t.tutorUserId}`, {
                state: { personName: t.name },
              })
            }
          >
            <DetailsCard
              icon={UserCheck}
              title={t.name}
              colorName="color-2"
              className="h-full cursor-pointer"
            >
              <DetailField label="Nom" value={t.name} />
              {t.program ? <DetailField label="Programme" value={t.program} /> : null}
              <DetailField label="Géré par" value={t.managedByName} />
            </DetailsCard>
          </button>
        ))
      )}
    </div>
  );
};
